import { render, staticRenderFns } from "./ParticaAdminBase.vue?vue&type=template&id=01fef2d4&"
import script from "./ParticaAdminBase.vue?vue&type=script&lang=ts&"
export * from "./ParticaAdminBase.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports